import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'ui-components/components/modal';
import { ModalHeader } from 'ui-components/components/modal/modal-header';
import { ModalFooter } from 'ui-components/components/modal/modal-footer';
import { ModalBody } from 'ui-components/components/modal/modal-body';
import { FloatTextArea } from 'ui-components/components/float-text-area';
import { FormattedMessage, useIntl } from 'react-intl';
import { Button } from 'ui-components/components/button';
import { MessageDescriptorPropType } from '../../../prop-types/intl';

import style from './email-return-label-modal.module.less';

export const SingleReturn = ({ emailTo = '', message, updateEmailTo, closeModal, sendReturnLabels }) => {
  const { formatMessage } = useIntl();
  return (
    <Modal className={style['email-return-label-modal']} size='small'>
      <ModalHeader closeModal={closeModal}>
        <FormattedMessage defaultMessage='Email Return Label' description='emailReturnLabel.title' id='ltRNke' />
      </ModalHeader>
      <ModalBody className={style['email-return-label-body']}>
        <div className={style.instructions}>
          <FormattedMessage
            defaultMessage='Send Return Label to one or more email addresses.'
            description='emailReturnLabel.instructions'
            id='pECEda'
          />
        </div>
        <FloatTextArea
          className={style['email-to-text-area']}
          label={formatMessage(message)}
          onChange={(value) => updateEmailTo(0, value)}
          value={emailTo}
        />
        <div className={style['comma-separated-instructions']}>
          <FormattedMessage
            defaultMessage='Separate multiple addresses using commas.'
            description='emailReturnLabel.commaSeparatedInstructions'
            id='uJovAI'
          />
        </div>
      </ModalBody>
      <ModalFooter className={style.footer}>
        <Button onClick={closeModal} theme='tertiary'>
          <FormattedMessage defaultMessage='Cancel' description='emailReturnLabel.cancel' id='6SJj0I' />
        </Button>
        <Button onClick={sendReturnLabels} theme='primary'>
          <FormattedMessage defaultMessage='Send' description='emailReturnLabel.send' id='qeVrcK' />
        </Button>
      </ModalFooter>
    </Modal>
  );
};

SingleReturn.propTypes = {
  emailTo: PropTypes.string,
  message: MessageDescriptorPropType.isRequired,
  updateEmailTo: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  sendReturnLabels: PropTypes.func.isRequired,
};
